import React, { useEffect, useState } from "react";
import {
  GeneratingImg,
  ImageContainer,
  MainContainer,
  Section,
} from "./styles";
import Typography from "../../../../components/Typography";
import SectionItem from "../../../../components/SectionItem";
import { Divider, Result } from "antd";
import useEnterprise from "../../hooks/useEnterprise";
import { SmartGoal } from "./types";
import { companyGoalsService } from "../../../../services/modules/companyGoals";
import { SkeletonLoading } from "../skeleton";
import Target from "../../../../assets/svg/target.svg";
import Button from "../../../../components/Button";
import ThemeColors from "../../../../themes/colors";
import CreateGoalModal from "./components/CreateGoalModal";

const SmartGoals: React.FC = (): JSX.Element => {
  const { enterpriseState } = useEnterprise();

  const [goalsData, setGoalsData] = useState<SmartGoal[]>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchCompanyGoals = (id: string) => {
    companyGoalsService
      .getCompanyGoals(id)
      .then((response) => setGoalsData(response))
      .finally(() => setIsLoading(false));
  };

  const defineGoalLabel = (grade: string) => {
    const parsed = Number(grade);

    if (parsed <= 3) {
      return "Pouca Prioridade";
    }
    if (parsed >= 8) {
      return "Alta Prioridade";
    }

    return "Prioridade Normal";
  };

  useEffect(() => {
    if (enterpriseState.selectedEnterprise)
      fetchCompanyGoals(enterpriseState.selectedEnterprise);
  }, [enterpriseState.selectedEnterprise]);

  return (
    <Section>
      {isLoading ? (
        <SkeletonLoading />
      ) : (
        <>
          {goalsData && goalsData.length > 0 ? (
            <MainContainer>
              {goalsData.length >= 3 ? (
                <Button
                  size="middle"
                  borderRadius="0.5rem"
                  style={{ width: "fit-content", float: "right" }}
                  backgroundColor={ThemeColors.Black200}
                  disabled
                >
                  <Typography
                    text="Limite de objetivos alcançado"
                    size="medium"
                    color="Bg300"
                    weight={400}
                  />
                </Button>
              ) : (
                <Button
                  size="large"
                  borderRadius="0.5rem"
                  style={{ width: "fit-content", float: "right" }}
                  backgroundColor={ThemeColors.Gradient100}
                  onClick={() => setIsModalOpen(true)}
                >
                  <Typography
                    text="Criar meu objetivo"
                    size="medium"
                    color="Bg300"
                    weight={400}
                  />
                </Button>
              )}
              <Typography
                text={enterpriseState.enterpriseData?.company_name}
                size="extraHuge"
                color="Black500"
                weight={700}
              />
              <SectionItem
                icon={"🏢"}
                title={"Site da Empresa"}
                description={enterpriseState.enterpriseData?.website || ""}
              />
              <Divider />
              {goalsData.map((goal, index) => (
                <>
                  <SectionItem
                    icon={"🎯"}
                    title={`Objetivo ${index + 1}`}
                    description={defineGoalLabel(goal.goal)}
                    isTitle
                  />
                  <SectionItem
                    icon={"🎯"}
                    title={"Específico"}
                    description={goal.s}
                  />
                  <SectionItem
                    icon={"📊"}
                    title={"Mensurável"}
                    description={goal.m}
                  />
                  <SectionItem
                    icon={"🤝"}
                    title={"Atingível"}
                    description={goal.a}
                  />
                  <SectionItem
                    icon={"⚖️"}
                    title={"Relevante"}
                    description={goal.r}
                  />
                  <SectionItem
                    icon={"🗓️"}
                    title={"Temporal"}
                    description={goal.t}
                  />
                  <Divider />
                </>
              ))}
            </MainContainer>
          ) : (
            <ImageContainer>
              <Result
                icon={<GeneratingImg src={Target} />}
                title="Vamos criar um objetivo para o seu Projeto"
                subTitle="Para isso, clique no botão abaixo e siga as instruções."
                extra={
                  <Button
                    size="large"
                    borderRadius="0.5rem"
                    style={{ width: "fit-content" }}
                    backgroundColor={ThemeColors.Gradient100}
                    onClick={() => setIsModalOpen(true)}
                  >
                    <Typography
                      text="Criar meu objetivo"
                      size="medium"
                      color="Bg300"
                      weight={400}
                    />
                  </Button>
                }
              />
            </ImageContainer>
          )}
        </>
      )}
      {isModalOpen && (
        <CreateGoalModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          onCreate={() => {
            setIsModalOpen(false);
            enterpriseState.selectedEnterprise &&
              fetchCompanyGoals(enterpriseState.selectedEnterprise);
          }}
        />
      )}
    </Section>
  );
};

export default SmartGoals;
